export default __webpack_public_path__ + "ef64d89.png";